<template>
	<div class="hdl-login p-4">
		<div class="hdl-auth-container mb-8">
			<div class="mb-5 flex flex-row justify-center items-center">
				<img src="/static/images/logo.svg" width="32" alt="logo" class="auth-medley-logo" />
			</div>
			<div class="hdl-heading-secondary text-center mb-5">
				Sign in
			</div>
			<div v-if="errors.length > 0" class="mb-5">
				<div class="auth-error mb-2" v-for="(error, index) of errors" :key="index">
					{{ error }}
				</div>
			</div>
			<div class="mb-5">
				<div class="mb-1 text-lg font-semibold">Email</div>
				<hdl-textbox
					v-model="email"
					hdl-style="auth"
					class="w-full"
					@enter="login"
					focus-on-mount
				/>
			</div>
			<div class="mb-5">
				<div class="mb-1 text-lg font-semibold">Password</div>
				<hdl-textbox
					v-model="password"
					hdl-style="auth"
					class="w-full"
					password
					@enter="login"
				/>
			</div>
			<div class="mb-8">
				<hdl-button
					@click.prevent="login"
					label="Sign in"
					hdl-style="primary"
					size="lg"
					class="w-full text-lg"
				/>
				<!--<google-signin-button />-->
			</div>
			<div class="text-center hdl-footnote-text mb-4">
				<div>
					Forgot your password?
					<a
						href="#"
						@click.prevent="$router.push('/account/password/reset/')"
					>Click here</a>.
				</div>
				<div class="mt-1" v-if="$workspace.info === null">
					Don't have an account?
					<a
						href="#"
						@click.prevent="$router.push('/account/register/')"
					>Sign up</a>.
				</div>
			</div>
			<div class="hdl-footnote-text text-center">
				By signing in you agree to the
				<a href="https://www.medley.so/terms" target="_blank">Terms of Service</a> and
				acknowledge the <a href="https://www.medley.so/privacy" target="_blank">Privacy Policy</a>.
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

import { fetcher, FetchResult } from '@/common/fetcher';

@Component
export default class LoginPage extends Vue {
	email: string = "";
	password: string = "";

	loginErrors: Array<string> = [];

	login(): void {
		if (!this.loginInformationValid) {
			// SHAKE THE FIELDS
			return;
		}

		fetcher.Post(
			'/account/login/',
			{
				email: this.email,
				password: this.password
			}
		).then(this.loginFetched);
	}

	loginFetched(result: FetchResult) {
		if (!result.response.ok) {
			return;
		}

		this.loginErrors = [];
		if (result.json.success) {
			let next: string | undefined = this.$route.query.next as string | undefined;

			if (next === undefined) {
				next = '/';
			}

			if (result.json.data && result.json.data.next) {
				next = result.json.data.next as string;
			}

			window.location.replace(next);
		} else {
			// TODO handle login form errors
			if (result.json.message) {
				this.loginErrors = [result.json.message];
			} else if (result.json.formErrors) {
				if (result.json.formErrors.email) {
					this.loginErrors.push(
						result.json.formErrors.email[0].message
					);
				}

				if (result.json.formErrors.password) {
					this.loginErrors.push(
						"Invalid credentials."
					);
				}
			}
		}

		console.log(this.loginErrors);
	}

	get errors(): Array<string> {
		const errors: Array<string> = [...this.loginErrors];

		if (this.$route.query.e) {
			switch(this.$route.query.e) {
				case 'IVTK-01':
					errors.push(
						'This invite is no longer valid.'
					);
				break;
			}
		}

		return errors;
	}

	get loginInformationValid(): boolean {
		return (
			this.email.trim().length > 0
			&& this.password.trim().length > 0
		);
	}
}
</script>

<style lang="scss">

.auth-error {
	@apply text-center bg-hdl-red-bg rounded py-2 text-hdl-red;
}
</style>
